import React, { useState, useEffect } from 'react';
import { 
  Box, Paper, Typography, Tabs, Tab, Table, TableBody, 
  TableCell, TableContainer, TableHead, TableRow, Chip,
  Alert, Button, Dialog, DialogTitle,
  DialogContent, TextField, DialogActions, FormControl,
  InputLabel, Select, MenuItem, IconButton, Switch, FormControlLabel, Grid, Card, CardContent
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import UpdateIcon from '@mui/icons-material/Update';

// Firebase Bağlantıları
import { collection, addDoc, doc, updateDoc, deleteDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase'; 

// Context
import { usePriceContext } from "../context/PriceContext";

// YARDIMCI FORMATERLER
const decimalFormatter = (number) => {
  if (typeof number !== "number" || isNaN(number)) return "-";
  return number.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// GÜNCELLENEN GÜVENLİ FORMATLAYICI
const formatSystemTime = (ts) => {
  try {
    if (!ts || isNaN(ts)) return "GÜNCELLENİYOR...";
    
    // Sayısal değeri saniyeden milisaniyeye çeviriyoruz
    const date = new Date(Number(ts) * 1000);
    
    // Geçersiz tarih kontrolü
    if (isNaN(date.getTime())) return "GEÇERSİZ TARİH";

    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: 'long',
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(date);
  } catch (err) {
    return "VERİ BEKLENİYOR...";
  }
};

const ReferansFiyatEkrani = () => {
  // 1. DÜZENLEME: systemTime ve errorMessage'ı context'ten çekiyoruz
  const { prices = [], systemTime, errorMessage } = usePriceContext();
  
  const [activeTab, setActiveTab] = useState(1); 
  const [formuller, setFormuller] = useState([]);   
  
  // --- GENEL AYARLAR ---
  const [genelAyarlar, setGenelAyarlar] = useState({
    aktif: false,          
    manuelHasAlis: "0", manuelHasSatis: "0",
    manuelOnsAlis: "0", manuelOnsSatis: "0", 
    manuelGumUsOnsAlis: "0", manuelGumUsOnsSatis: "0",
    manuelDolarAlis: "0", manuelDolarSatis: "0",
    manuelEuroAlis: "0", manuelEuroSatis: "0",
    manuelPariteAlis: "0", manuelPariteSatis: "0" 
  });
  const [settingsLoading, setSettingsLoading] = useState(false);

  // Modallar
  const [openNormalModal, setOpenNormalModal] = useState(false); 
  const [openAcilModal, setOpenAcilModal] = useState(false);     
  const [editingId, setEditingId] = useState(null);
  
  // Form Dataları
  const [formData, setFormData] = useState({
    ad: '', kaynak: 'ALTINTRY', alisCarpan: '1', satisCarpan: '1',
    alisIscilik: '0', satisIscilik: '0', birim: 'TL',
    isManual: false, manualBuy: '0', manualSell: '0', 
    acilKaynak: 'MANUEL_HAS', acilAlisCarpan: '0', acilSatisCarpan: '0',
    createdAt: null
  });

  // --- ÜRÜN GRUPLARI TANIMI ---
  const masterList = ["Eski Ziynet Çeyrek", "Yeni Ziynet Çeyrek", "Cumhuriyet Ata", "1 Gram 24 Ayar", "1 Gram 22 Ayar"];
  const autoList = [
    "Eski Ziynet Yarım", "Eski Ziynet Tam", "Eski Ziynet 2.5'lu Gremse", "Eski Ziynet Beşli",
    "Yeni Ziynet Yarım", "Yeni Ziynet Tam", "Yeni Ziynet 2.5'lu Gremse", "Yeni Ziynet Beşli",
    "Cumhuriyet Ata Çeyrek", "Cumhuriyet Ata Yarım", "Cumhuriyet Ata 2.5'lu Gremse", "Cumhuriyet Ata Besli",
    "Reşat Çeyrek", "Reşat Yarım", "Reşat", "Reşat 2.5'lu Gremse", "Reşat Beşli",
    "0.50 Gram 24 Ayar", "0.25 Gram 24 Ayar", "2.50 Gram 24 Ayar", "5 Gram 24 Ayar", "10 Gram 24 Ayar", "20 Gram 24 Ayar", "50 Gram 24 Ayar", "100 Gram 24 Ayar",
    "0.50 Gram 22 Ayar", "0.25 Gram 22 Ayar"
  ];

  // --- OTOMASYON MOTORU ---
  const updateLinkedProducts = async (masterData, targetMode = "both") => {
    const { ad, alisCarpan, satisCarpan, acilAlisCarpan, acilSatisCarpan } = masterData;
    let batch = [];

    // 1. ESKİ ZİYNET GRUBU
    if (ad === "Eski Ziynet Çeyrek") {
        const ziynetler = [
            { name: "Eski Ziynet Yarım", k: 2 },
            { name: "Eski Ziynet Tam", k: 4 },
            { name: "Eski Ziynet 2.5'lu Gremse", k: 10 },
            { name: "Eski Ziynet Beşli", k: 20 }
        ];
        ziynetler.forEach(z => {
            const found = formuller.find(f => f.ad === z.name);
            if (found) {
                let up = {};
                if (targetMode === "normal" || targetMode === "both") {
                    up.alisCarpan = Number(alisCarpan) * z.k;
                    up.satisCarpan = Number(satisCarpan) * z.k;
                }
                if (targetMode === "acil" || targetMode === "both") {
                    up.acilAlisCarpan = Number(acilAlisCarpan) * z.k;
                    up.acilSatisCarpan = Number(acilSatisCarpan) * z.k;
                }
                batch.push(updateDoc(doc(db, "formuller", found.id), up));
            }
        });
    }

    // 2. YENİ ZİYNET GRUBU
    if (ad === "Yeni Ziynet Çeyrek") {
        const ziynetler = [
            { name: "Yeni Ziynet Yarım", k: 2 },
            { name: "Yeni Ziynet Tam", k: 4 },
            { name: "Yeni Ziynet 2.5'lu Gremse", k: 10 },
            { name: "Yeni Ziynet Beşli", k: 20 }
        ];
        ziynetler.forEach(z => {
            const found = formuller.find(f => f.ad === z.name);
            if (found) {
                let up = {};
                if (targetMode === "normal" || targetMode === "both") {
                    up.alisCarpan = Number(alisCarpan) * z.k;
                    up.satisCarpan = Number(satisCarpan) * z.k;
                }
                if (targetMode === "acil" || targetMode === "both") {
                    up.acilAlisCarpan = Number(acilAlisCarpan) * z.k;
                    up.acilSatisCarpan = Number(acilSatisCarpan) * z.k;
                }
                batch.push(updateDoc(doc(db, "formuller", found.id), up));
            }
        });
    }

    // 3. ATA & REŞAT GRUBU
    if (ad === "Cumhuriyet Ata") {
        const atalar = [
            { name: "Cumhuriyet Ata Çeyrek", aK: 0.25, sK: 0.25 * 1.08 },
            { name: "Cumhuriyet Ata Yarım", aK: 0.5, sK: 0.5 * 1.05 },
            { name: "Cumhuriyet Ata 2.5'lu Gremse", aK: 2.5, sK: 2.5 },
            { name: "Cumhuriyet Ata Besli", aK: 5, sK: 5 },
            { name: "Reşat Çeyrek", aK: 0.25 * 1.005, sK: 0.25 * 1.05 * 1.08 },
            { name: "Reşat Yarım", aK: 0.5 * 1.005, sK: 0.5 * 1.05 * 1.05 },
            { name: "Reşat", aK: 1.005, sK: 1.05 }, // 1 Adet üzerinden carpan
            { name: "Reşat 2.5'lu Gremse", aK: 2.5 * 1.005, sK: 2.5 * 1.05 },
            { name: "Reşat Beşli", aK: 5 * 1.005, sK: 5 * 1.05 }
        ];
        atalar.forEach(a => {
            const found = formuller.find(f => f.ad === a.name);
            if (found) {
                let up = {};
                if (targetMode === "normal" || targetMode === "both") {
                    up.alisCarpan = Number(alisCarpan) * a.aK;
                    up.satisCarpan = Number(satisCarpan) * a.sK;
                }
                if (targetMode === "acil" || targetMode === "both") {
                    up.acilAlisCarpan = Number(acilAlisCarpan) * a.aK;
                    up.acilSatisCarpan = Number(acilSatisCarpan) * a.sK;
                }
                batch.push(updateDoc(doc(db, "formuller", found.id), up));
            }
        });
    }

    // 4. 24 AYAR GRAM GRUBU
    if (ad === "1 Gram 24 Ayar") {
        const gramlar = [
            { name: "0.50 Gram 24 Ayar", aK: 0.5, sK: 0.5 * 1.25 }, // %25 Satış İşçiliği
            { name: "0.25 Gram 24 Ayar", aK: 0.25, sK: 0.25 * 1.30 }, // %25 Satış İşçiliği
            { name: "2.50 Gram 24 Ayar", aK: 2.5, sK: 2.5 },
            { name: "5 Gram 24 Ayar", aK: 5, sK: 5 },
            { name: "10 Gram 24 Ayar", aK: 10, sK: 10 },
            { name: "20 Gram 24 Ayar", aK: 20, sK: 20 },
            { name: "50 Gram 24 Ayar", aK: 50, sK: 50 },
            { name: "100 Gram 24 Ayar", aK: 100, sK: 100 }
        ];
        gramlar.forEach(g => {
            const found = formuller.find(f => f.ad === g.name);
            if (found) {
                let up = {};
                if (targetMode === "normal" || targetMode === "both") {
                    up.alisCarpan = Number(alisCarpan) * g.aK;
                    up.satisCarpan = Number(satisCarpan) * g.sK;
                }
                if (targetMode === "acil" || targetMode === "both") {
                    up.acilAlisCarpan = Number(acilAlisCarpan) * g.aK;
                    up.acilSatisCarpan = Number(acilSatisCarpan) * g.sK;
                }
                batch.push(updateDoc(doc(db, "formuller", found.id), up));
            }
        });
    }

    // 5. 22 AYAR GRAM GRUBU (YENİ EKLENEN KOMUT)
    if (ad === "1 Gram 22 Ayar") {
        const gramlar22 = [
            { name: "0.50 Gram 22 Ayar", aK: 0.5, sK: 0.5 * 1.25 },
            { name: "0.25 Gram 22 Ayar", aK: 0.25, sK: 0.25 * 1.30 }
        ];
        gramlar22.forEach(g => {
            const found = formuller.find(f => f.ad === g.name);
            if (found) {
                let up = {};
                if (targetMode === "normal" || targetMode === "both") {
                    up.alisCarpan = Number(alisCarpan) * g.aK;
                    up.satisCarpan = Number(satisCarpan) * g.sK;
                }
                if (targetMode === "acil" || targetMode === "both") {
                    up.acilAlisCarpan = Number(acilAlisCarpan) * g.aK;
                    up.acilSatisCarpan = Number(acilSatisCarpan) * g.sK;
                }
                batch.push(updateDoc(doc(db, "formuller", found.id), up));
            }
        });
    }

    await Promise.all(batch);
  };

  // --- VERİ ÇEKME ---
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "formuller"), (snapshot) => {
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      list.sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0));
      setFormuller(list);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, "ayarlar", "genel_durum"), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setGenelAyarlar({
            aktif: data.aktif,
            manuelHasAlis: String(data.manuelHasAlis || 0), manuelHasSatis: String(data.manuelHasSatis || 0),
            manuelOnsAlis: String(data.manuelOnsAlis || 0), manuelOnsSatis: String(data.manuelOnsSatis || 0),
            manuelGumUsOnsAlis: String(data.manuelGumUsOnsAlis || 0), manuelGumUsOnsSatis: String(data.manuelGumUsOnsSatis || 0),
            manuelDolarAlis: String(data.manuelDolarAlis || 0), manuelDolarSatis: String(data.manuelDolarSatis || 0),
            manuelEuroAlis: String(data.manuelEuroAlis || 0), manuelEuroSatis: String(data.manuelEuroSatis || 0),
            manuelPariteAlis: String(data.manuelPariteAlis || 0), manuelPariteSatis: String(data.manuelPariteSatis || 0)
        });
      }
    });
    return () => unsubscribe();
  }, []);

  const handleCurrencyChange = (field, value) => {
    let newSettings = { ...genelAyarlar, [field]: value };
    const parseVal = (v) => (!v ? 0 : parseFloat(String(v).replace(',', '.')) || 0);

    if (field.includes('Dolar') || field.includes('Euro')) {
        const dAlis = field === 'manuelDolarAlis' ? parseVal(value) : parseVal(genelAyarlar.manuelDolarAlis);
        const eAlis = field === 'manuelEuroAlis' ? parseVal(value) : parseVal(genelAyarlar.manuelEuroAlis);
        if (dAlis > 0 && eAlis > 0) newSettings.manuelPariteAlis = (eAlis / dAlis).toFixed(4);
    }
    setGenelAyarlar(newSettings);
  };

  const handleAcilDurumToggle = async (e) => {
      const yeniDurum = e.target.checked;
      setGenelAyarlar(prev => ({ ...prev, aktif: yeniDurum }));
      try {
          await updateDoc(doc(db, "ayarlar", "genel_durum"), { aktif: yeniDurum });
      } catch (error) {
          setGenelAyarlar(prev => ({ ...prev, aktif: !yeniDurum }));
      }
  };

  const saveGeneralSettings = async () => {
    setSettingsLoading(true);
    const cleanSave = (val) => (!val ? 0 : parseFloat(String(val).replace(',', '.')) || 0);
    try {
      await updateDoc(doc(db, "ayarlar", "genel_durum"), {
        manuelHasAlis: cleanSave(genelAyarlar.manuelHasAlis), manuelHasSatis: cleanSave(genelAyarlar.manuelHasSatis),
        manuelOnsAlis: cleanSave(genelAyarlar.manuelOnsAlis), manuelOnsSatis: cleanSave(genelAyarlar.manuelOnsSatis),
        manuelGumUsOnsAlis: cleanSave(genelAyarlar.manuelGumUsOnsAlis), manuelGumUsOnsSatis: cleanSave(genelAyarlar.manuelGumUsOnsSatis),
        manuelDolarAlis: cleanSave(genelAyarlar.manuelDolarAlis), manuelDolarSatis: cleanSave(genelAyarlar.manuelDolarSatis),
        manuelEuroAlis: cleanSave(genelAyarlar.manuelEuroAlis), manuelEuroSatis: cleanSave(genelAyarlar.manuelEuroSatis),
        manuelPariteAlis: cleanSave(genelAyarlar.manuelPariteAlis), manuelPariteSatis: cleanSave(genelAyarlar.manuelPariteSatis),
      });
      alert("Genel fiyatlar başarıyla güncellendi.");
    } catch (error) { alert("Hata oluştu!"); }
    setSettingsLoading(false);
  };

  // --- HESAPLAMA MOTORLARI ---
  const calculateNormal = (formul) => {
    if (formul.isManual) return { alis: decimalFormatter(Number(formul.manualBuy)), satis: decimalFormatter(Number(formul.manualSell)) };
    
    // PriceContext içindeki Büyük Harf standardına göre arama yapıyoruz
    const sourceData = prices.find(p => p.currencyCode === formul.kaynak.toUpperCase());
    
    if (!sourceData) return { alis: "VERİ YOK", satis: "VERİ YOK" };

    const baseAlis = parseFloat(sourceData?.buy) || 0;
    const baseSatis = parseFloat(sourceData?.sell) || 0;
    const hAlis = (baseAlis * parseFloat(formul.alisCarpan)) + parseFloat(formul.alisIscilik);
    const hSatis = (baseSatis * parseFloat(formul.satisCarpan)) + parseFloat(formul.satisIscilik);
    return { alis: decimalFormatter(hAlis), satis: decimalFormatter(hSatis) };
  };

  const calculateAcil = (formul) => {
    const getVal = (val) => (!val ? 0 : parseFloat(String(val).replace(',', '.')) || 0);
    const effectiveSource = formul.acilKaynak || 'MANUEL_HAS';
    let baseAlis = getVal(genelAyarlar.manuelHasAlis);
    let baseSatis = getVal(genelAyarlar.manuelHasSatis);

    if (effectiveSource === "OTO_EURKG_PARITE") {
        const onsAlis = getVal(genelAyarlar.manuelOnsAlis);
        const pariteAlis = getVal(genelAyarlar.manuelPariteAlis) || 1;
        baseAlis = (onsAlis * 32.15) / pariteAlis;
        baseSatis = (getVal(genelAyarlar.manuelOnsSatis) * 32.15) / (getVal(genelAyarlar.manuelPariteSatis) || 1);
    }
    return { 
        alis: decimalFormatter(baseAlis * parseFloat(formul.acilAlisCarpan || 0)), 
        satis: decimalFormatter(baseSatis * parseFloat(formul.acilSatisCarpan || 0)) 
    };
  };

  // --- CRUD İŞLEMLERİ ---
  const handleOpenNormalModal = (item = null) => {
    setEditingId(item ? item.id : null);
    if (item) setFormData({ ...item });
    else setFormData({ ad: '', kaynak: 'ALTINTRY', alisCarpan: '1', satisCarpan: '1', alisIscilik: '0', satisIscilik: '0', birim: 'TL', isManual: false, manualBuy: 0, manualSell: 0, acilKaynak: 'MANUEL_HAS', acilAlisCarpan: '0', acilSatisCarpan: '0', createdAt: null });
    setOpenNormalModal(true);
  };

  const saveNormal = async () => {
    try {
      const docData = { ...formData, 
        alisCarpan: Number(formData.alisCarpan), satisCarpan: Number(formData.satisCarpan),
        alisIscilik: Number(formData.alisIscilik), satisIscilik: Number(formData.satisIscilik),
        manualBuy: Number(formData.manualBuy), manualSell: Number(formData.manualSell),
        acilAlisCarpan: Number(formData.acilAlisCarpan || 0), acilSatisCarpan: Number(formData.acilSatisCarpan || 0),
        createdAt: editingId ? (formData.createdAt || serverTimestamp()) : serverTimestamp()
      };
      if (editingId) await updateDoc(doc(db, "formuller", editingId), docData);
      else await addDoc(collection(db, "formuller"), docData);
      
      if (masterList.includes(formData.ad)) await updateLinkedProducts(docData, "normal");
      
      setOpenNormalModal(false);
    } catch (e) { alert("Kaydetme hatası!"); }
  };

  const handleOpenAcilModal = (item) => {
    setEditingId(item.id);
    setFormData({ ...item });
    setOpenAcilModal(true);
  };

  const saveAcil = async () => {
    try {
        const up = { acilKaynak: formData.acilKaynak, acilAlisCarpan: Number(formData.acilAlisCarpan), acilSatisCarpan: Number(formData.acilSatisCarpan) };
        await updateDoc(doc(db, "formuller", editingId), up);
        if (masterList.includes(formData.ad)) await updateLinkedProducts({ ...formData, ...up }, "acil");
        setOpenAcilModal(false);
    } catch (e) { alert("Güncelleme hatası!"); }
  };

  return (
    <Box className="rf-page" sx={{ p: 3, backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      
      <Box className="rf-header-row" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography className="rf-page-title" variant="h4" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Fiyat Yönetim Merkezi</Typography>
        
        <Box className="rf-api-box" sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#fff', p: 1.5, borderRadius: 2, boxShadow: 1 }}>
            <UpdateIcon color="primary" />
            <Box>
                <Typography variant="caption" display="block" color="textSecondary" sx={{ fontWeight: 'bold', lineHeight: 1 }}>SON API GÜNCELLEME</Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
                    {formatSystemTime(systemTime)}
                </Typography>
            </Box>
        </Box>
      </Box>

      {/* 2. DÜZENLEME: errorMessage varsa veya veri yoksa uyarı çıkar */}
      {(errorMessage || !prices || prices.length === 0) && (
        <Alert className="rf-alert" severity="error" variant="filled" sx={{ mb: 3, fontWeight: 'bold' }}>
            {errorMessage || "DİKKAT: API BAĞLANTISI SAĞLANAMADI! FİYATLAR GÜNCEL DEĞİL."}
        </Alert>
      )}

      {/* --- ÜST PANEL --- */}
      <Card className="rf-settings-card" sx={{ mb: 4, border: '2px solid', borderColor: genelAyarlar.aktif ? '#d32f2f' : '#1976d2', boxShadow: 3 }}>
        <CardContent>
            <Box className="rf-settings-title-row" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                {genelAyarlar.aktif ? <WarningAmberIcon color="error" sx={{ mr: 1, fontSize: 40 }} /> : <SettingsIcon color="primary" sx={{ mr: 1 }} />}
                <Typography variant="h6" color={genelAyarlar.aktif ? 'error' : 'primary'} fontWeight="bold">
                    {genelAyarlar.aktif ? "⚠️ SİSTEM ACİL DURUM MODUNDA (MANUEL)" : "✅ SİSTEM NORMAL (OTOMATİK) MODDA"}
                </Typography>
            </Box>
            <Grid container spacing={2} className="rf-settings-grid">
                <Grid item xs={12} md={2} className="rf-settings-switch" sx={{display:'flex', alignItems:'center'}}>
                    <Paper elevation={0} sx={{ p: 2, bgcolor: genelAyarlar.aktif ? '#ffebee' : '#e3f2fd', border: '1px solid #ddd', width:'100%', textAlign:'center' }}>
                        <FormControlLabel control={<Switch checked={genelAyarlar.aktif} onChange={handleAcilDurumToggle} color="error"/>} label={<Typography fontWeight="bold">{genelAyarlar.aktif ? "KAPAT" : "AÇ"}</Typography>} />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={8} className="rf-manual-fields-wrap">
                    <Grid container spacing={2} className="rf-manual-fields-grid">
                        <Grid item xs={3} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#b28900'}}>MANUEL HAS ALTIN</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelHasAlis} onChange={(e) => handleCurrencyChange('manuelHasAlis', e.target.value)} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelHasSatis} onChange={(e) => handleCurrencyChange('manuelHasSatis', e.target.value)} placeholder="Satış"/></Box></Grid>
                        <Grid item xs={3} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#ff9800'}}>MANUEL ONS</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelOnsAlis} onChange={(e) => handleCurrencyChange('manuelOnsAlis', e.target.value)} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelOnsSatis} onChange={(e) => handleCurrencyChange('manuelOnsSatis', e.target.value)} placeholder="Satış"/></Box></Grid>
                        <Grid item xs={3} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#607d8b'}}>MANUEL GÜMÜŞ ONS</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelGumUsOnsAlis} onChange={(e) => handleCurrencyChange('manuelGumUsOnsAlis', e.target.value)} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelGumUsOnsSatis} onChange={(e) => handleCurrencyChange('manuelGumUsOnsSatis', e.target.value)} placeholder="Satış"/></Box></Grid>
                        <Grid item xs={3} className="rf-manual-field"></Grid>
                        <Grid item xs={2} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#2e7d32'}}>MANUEL DOLAR</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelDolarAlis} onChange={(e) => handleCurrencyChange('manuelDolarAlis', e.target.value)} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelDolarSatis} onChange={(e) => handleCurrencyChange('manuelDolarSatis', e.target.value)} placeholder="Satış"/></Box></Grid>
                        <Grid item xs={2} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#1565c0'}}>MANUEL EURO</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelEuroAlis} onChange={(e) => handleCurrencyChange('manuelEuroAlis', e.target.value)} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelEuroSatis} onChange={(e) => handleCurrencyChange('manuelEuroSatis', e.target.value)} placeholder="Satış"/></Box></Grid>
                        <Grid item xs={2} className="rf-manual-field"><Typography variant="caption" sx={{fontWeight:'bold', color: '#673ab7'}}>EURO/USD</Typography><Box className="rf-field-pair" sx={{display:'flex', gap:1}}><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelPariteAlis} onChange={(e) => setGenelAyarlar({...genelAyarlar, manuelPariteAlis: e.target.value})} placeholder="Alış"/><TextField type="text" size="small" disabled={!genelAyarlar.aktif} value={genelAyarlar.manuelPariteSatis} onChange={(e) => setGenelAyarlar({...genelAyarlar, manuelPariteSatis: e.target.value})} placeholder="Satış"/></Box></Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={2} className="rf-settings-save" sx={{display:'flex', alignItems:'center'}}><Button variant="contained" color="secondary" fullWidth size="large" sx={{height: '80%'}} startIcon={<SaveIcon />} onClick={saveGeneralSettings} disabled={settingsLoading}>GÜNCELLE</Button></Grid>
            </Grid>
        </CardContent>
      </Card>

      <Paper className="rf-tabs-paper" sx={{ mb: 3 }}>
        <Tabs className="rf-tabs" value={activeTab} onChange={(e, v) => setActiveTab(v)} centered indicatorColor={activeTab > 2 ? "error" : "primary"}>
          <Tab label="1. Ham Veriler" />
          <Tab label="2. Ürün Tanımları" />
          <Tab label="3. Normal Önizleme" />
          <Tab label="🔴 ACİL TANIMLAR" sx={{ color: 'red', fontWeight:'bold' }} />
          <Tab label="🔴 ACİL ÖNİZLEME" sx={{ color: 'red', fontWeight:'bold' }} />
        </Tabs>
      </Paper>

      {/* SEKME 1: HAM VERİLER */}
      {activeTab === 0 && (
        <TableContainer className="rf-table-wrap" component={Paper}>
            <Table className="rf-data-table" size="small">
                <TableHead sx={{ bgcolor: '#2C2C2C' }}><TableRow><TableCell sx={{ color: 'white' }}>KOD</TableCell><TableCell sx={{ color: 'white' }} align="right">ALIŞ</TableCell><TableCell sx={{ color: 'white' }} align="right">SATIŞ</TableCell></TableRow></TableHead>
                <TableBody>
                  {prices.length === 0 ? (
                    <TableRow><TableCell colSpan={3} align="center" sx={{ py: 3, color: 'red', fontWeight: 'bold' }}>VERİ BULUNAMADI</TableCell></TableRow>
                  ) : (
                    prices.map((p) => (<TableRow key={p.currencyCode}><TableCell>{p.currencyCode}</TableCell><TableCell align="right">{decimalFormatter(p.buy)}</TableCell><TableCell align="right">{decimalFormatter(p.sell)}</TableCell></TableRow>))
                  )}
                </TableBody>
            </Table>
        </TableContainer>
      )}

      {/* SEKME 2: ÜRÜN TANIMLARI */}
      {activeTab === 1 && (
        <TableContainer className="rf-table-wrap" component={Paper}>
          <Box className="rf-tab-toolbar" sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#fff3e0' }}>
            <Alert severity="warning">Ürün Tanımları (Master Ürün Değişimi Alt Grubu Günceller)</Alert>
            <Button variant="contained" color="warning" startIcon={<AddCircleIcon />} onClick={() => handleOpenNormalModal()}>Yeni Ürün</Button>
          </Box>
          <Table className="rf-data-table">
            <TableHead sx={{ bgcolor: '#ef6c00' }}><TableRow><TableCell sx={{ color: 'white' }}>Ürün Adı</TableCell><TableCell sx={{ color: 'white' }}>Kaynak</TableCell><TableCell sx={{ color: 'white' }}>Çarpanlar</TableCell><TableCell sx={{ color: 'white' }} align="right">İşlem</TableCell></TableRow></TableHead>
            <TableBody>
              {formuller.map((row) => {
                const isMaster = masterList.includes(row.ad);
                const isAuto = autoList.includes(row.ad);
                return (
                  <TableRow key={row.id}>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {row.ad}
                      {isMaster && <Chip label="MASTER" size="small" color="primary" sx={{ ml: 1, height: 20, fontSize: 10 }} />}
                      {isAuto && <Chip label="OTOMATİK" size="small" variant="outlined" sx={{ ml: 1, height: 20, fontSize: 10, color: '#666' }} />}
                    </TableCell>
                    <TableCell><Chip label={row.kaynak} size="small" /></TableCell>
                    <TableCell>{row.alisCarpan} / {row.satisCarpan}</TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => handleOpenNormalModal(row)}><EditIcon /></IconButton>
                      <IconButton size="small" color="error" onClick={() => deleteDoc(doc(db, "formuller", row.id))}><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* SEKME 3: NORMAL ÖNİZLEME */}
      {activeTab === 2 && (
        <TableContainer className="rf-table-wrap" component={Paper}>
            <Table className="rf-data-table"><TableHead sx={{ bgcolor: '#2e7d32' }}><TableRow><TableCell sx={{color:'white'}}>Ürün</TableCell><TableCell sx={{color:'white'}} align="right">Alış</TableCell><TableCell sx={{color:'white'}} align="right">Satış</TableCell></TableRow></TableHead>
            <TableBody>{formuller.map(row => { const res = calculateNormal(row); return <TableRow key={row.id}><TableCell>{row.ad}</TableCell><TableCell align="right" sx={{ color: res.alis === "VERİ YOK" ? 'red' : 'inherit', fontWeight: res.alis === "VERİ YOK" ? 'bold' : 'normal' }}>{res.alis}</TableCell><TableCell align="right" sx={{ color: res.satis === "VERİ YOK" ? 'red' : 'inherit', fontWeight: res.satis === "VERİ YOK" ? 'bold' : 'normal' }}>{res.satis}</TableCell></TableRow> })}</TableBody></Table>
        </TableContainer>
      )}

      {/* SEKME 4: ACİL TANIMLAR */}
      {activeTab === 3 && (
        <TableContainer className="rf-table-wrap" component={Paper}>
          <Box className="rf-tab-toolbar" sx={{ p: 2, bgcolor: '#ffebee' }}><Alert severity="error">ACİL TANIMLAR: Master çarpanı bağlı ürünleri otomatik günceller.</Alert></Box>
          <Table className="rf-data-table"><TableHead sx={{ bgcolor: '#d32f2f' }}><TableRow><TableCell sx={{ color: 'white' }}>Ürün Adı</TableCell><TableCell sx={{ color: 'white' }}>Kaynak</TableCell><TableCell sx={{ color: 'white' }}>Acil Çarpanlar</TableCell><TableCell sx={{ color: 'white' }} align="right">İşlem</TableCell></TableRow></TableHead>
            <TableBody>
              {formuller.map((row) => {
                const isMaster = masterList.includes(row.ad);
                const isAuto = autoList.includes(row.ad);
                return (
                  <TableRow key={row.id}>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {row.ad}
                      {isMaster && <Chip label="MASTER" size="small" sx={{ ml: 1, height: 20, fontSize: 10, bgcolor: '#d32f2f', color: 'white' }} />}
                      {isAuto && <Chip label="OTOMATİK" size="small" variant="outlined" sx={{ ml: 1, height: 20, fontSize: 10, color: '#d32f2f', borderColor: '#d32f2f' }} />}
                    </TableCell>
                    <TableCell>{row.acilKaynak || 'MANUEL_HAS'}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>{`${row.acilAlisCarpan || 0} / ${row.acilSatisCarpan || 0}`}</TableCell>
                    <TableCell align="right"><Button variant="outlined" color="error" size="small" onClick={() => handleOpenAcilModal(row)}>Acil Ayarı</Button></TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* SEKME 5: ACİL ÖNİZLEME */}
      {activeTab === 4 && (
        <TableContainer className="rf-table-wrap" component={Paper}>
            <Table className="rf-data-table"><TableHead sx={{ bgcolor: '#b71c1c' }}><TableRow><TableCell sx={{ color: 'white' }}>ÜRÜN</TableCell><TableCell sx={{ color: 'white' }} align="right">ACİL ALIŞ</TableCell><TableCell sx={{ color: 'white' }} align="right">ACİL SATIŞ</TableCell></TableRow></TableHead>
            <TableBody>{formuller.map(row => { const sonuc = calculateAcil(row); return <TableRow key={row.id}><TableCell>{row.ad}</TableCell><TableCell align="right" sx={{ fontWeight: 'bold', color: '#1b5e20' }}>{sonuc.alis}</TableCell><TableCell align="right" sx={{ fontWeight: 'bold', color: '#b71c1c' }}>{sonuc.satis}</TableCell></TableRow> })}</TableBody></Table>
        </TableContainer>
      )}

      {/* MODALLAR */}
      <Dialog className="rf-dialog" open={openNormalModal} onClose={() => setOpenNormalModal(false)} maxWidth="sm" fullWidth><DialogTitle>Ürün Tanımı</DialogTitle><DialogContent><Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}><TextField label="Ad" value={formData.ad} onChange={(e) => setFormData({...formData, ad: e.target.value})} /><FormControl fullWidth><InputLabel>Kaynak</InputLabel><Select value={formData.kaynak} onChange={(e) => setFormData({...formData, kaynak: e.target.value})}>{prices.map(p => <MenuItem key={p.currencyCode} value={p.currencyCode}>{p.currencyCode}</MenuItem>)}</Select></FormControl><Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}><TextField label="Alış Çarpan" value={formData.alisCarpan} onChange={(e) => setFormData({...formData, alisCarpan: e.target.value})} /><TextField label="Satış Çarpan" value={formData.satisCarpan} onChange={(e) => setFormData({...formData, satisCarpan: e.target.value})} /></Box></Box></DialogContent><DialogActions><Button onClick={() => setOpenNormalModal(false)}>İptal</Button><Button onClick={saveNormal} variant="contained">Kaydet</Button></DialogActions></Dialog>

      <Dialog className="rf-dialog" open={openAcilModal} onClose={() => setOpenAcilModal(false)} maxWidth="sm" fullWidth><DialogTitle sx={{color: 'red'}}>Acil Ayarı ({formData.ad})</DialogTitle><DialogContent><Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}><FormControl fullWidth><InputLabel>Kaynak</InputLabel><Select value={formData.acilKaynak || 'MANUEL_HAS'} onChange={(e) => setFormData({...formData, acilKaynak: e.target.value})}><MenuItem value="MANUEL_HAS">MANUEL HAS</MenuItem><MenuItem value="OTO_EURKG_PARITE">OTO: EUR/KG (Ons/Parite)</MenuItem></Select></FormControl><Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}><TextField label="Acil Alış Çarpan" value={formData.acilAlisCarpan} onChange={(e) => setFormData({...formData, acilAlisCarpan: e.target.value})} /><TextField label="Acil Satış Çarpan" value={formData.acilSatisCarpan} onChange={(e) => setFormData({...formData, acilSatisCarpan: e.target.value})} /></Box></Box></DialogContent><DialogActions><Button onClick={() => setOpenAcilModal(false)}>İptal</Button><Button onClick={saveAcil} variant="contained" color="error">Kaydet</Button></DialogActions></Dialog>
      <style>{`
        /* --- MOBİL: Referans Fiyat (masaüstü sx stillerine dokunulmaz) --- */
        @media (max-width: 600px) {
          .rf-page {
            min-height: 0 !important;
            height: auto !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            overflow-x: hidden !important;
            padding: 8px 4px 80px !important;
            box-sizing: border-box !important;
          }

          .rf-header-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 10px !important;
            margin-bottom: 16px !important;
          }

          .rf-page-title {
            font-size: 1.35rem !important;
            line-height: 1.2 !important;
          }

          .rf-api-box {
            width: 100% !important;
            box-sizing: border-box !important;
          }

          .rf-settings-card {
            margin-bottom: 16px !important;
          }

          .rf-settings-title-row {
            flex-wrap: wrap !important;
            gap: 8px !important;
          }

          .rf-settings-title-row .MuiTypography-h6 {
            font-size: 0.95rem !important;
            line-height: 1.35 !important;
          }

          .rf-settings-grid > .MuiGrid-item,
          .rf-manual-fields-grid > .MuiGrid-item {
            width: 100% !important;
            max-width: 100% !important;
            flex-basis: 100% !important;
          }

          .rf-manual-field:empty {
            display: none !important;
          }

          /* Alis/Satis alt alta yazilinca sagda yarim ekran bos kaliyor ve
             panel iki katina cikiyordu; yan yana rahat siğiyorlar. */
          .rf-field-pair {
            flex-direction: row !important;
            gap: 8px !important;
          }

          .rf-field-pair .MuiTextField-root {
            flex: 1 1 0% !important;
            width: auto !important;
            min-width: 0 !important;
          }

          .rf-field-pair .MuiInputBase-input {
            font-size: 16px !important;
          }

          .rf-settings-save .MuiButton-root {
            height: auto !important;
            min-height: 44px !important;
            margin-top: 4px !important;
          }

          .rf-tabs-paper {
            margin-bottom: 12px !important;
            overflow: hidden !important;
          }

          .rf-tabs-paper .MuiTabs-root {
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
          }

          .rf-tabs-paper .MuiTabs-scroller {
            overflow-x: auto !important;
          }

          .rf-tabs-paper .MuiTabs-flexContainer {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
          }

          .rf-tabs-paper .MuiTab-root {
            min-width: 88px !important;
            max-width: 130px !important;
            font-size: 10px !important;
            padding: 8px 8px !important;
            line-height: 1.2 !important;
            white-space: normal !important;
          }

          .rf-tab-toolbar {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 10px !important;
          }

          .rf-tab-toolbar .MuiAlert-root {
            width: 100% !important;
            font-size: 12px !important;
          }

          /* Dugme ekran boyunca uzamasin; icerigi kadar yetiyor */
          .rf-tab-toolbar .MuiButton-root {
            width: auto !important;
            min-width: 150px !important;
            align-self: flex-end !important;
            min-height: 40px !important;
          }

          .rf-table-wrap {
            overflow-x: auto !important;
            max-width: 100% !important;
            min-width: 0 !important;
            -webkit-overflow-scrolling: touch;
          }

          .rf-data-table {
            min-width: 560px !important;
          }

          .rf-data-table .MuiTableCell-root {
            font-size: 12px !important;
            padding: 8px 6px !important;
          }

          .rf-data-table .MuiChip-root {
            margin-top: 4px !important;
            margin-left: 0 !important;
            display: inline-flex !important;
          }

          .rf-dialog .MuiDialog-paper {
            width: calc(100vw - 32px) !important;
            max-width: calc(100vw - 32px) !important;
            margin: 16px !important;
          }

          .rf-dialog .MuiInputBase-input {
            font-size: 16px !important;
          }
        }
      `}</style>
    </Box>
  );
};

export default ReferansFiyatEkrani;